import type { NextPage } from 'next'
import { LabelGalleryProps } from '@/client/modules/LabelGallery/types'
import { getCMSContent } from '@/client/utils'
import { LabelGallery } from '@/client/modules/LabelGallery'

const LabelGalleryPage: NextPage<LabelGalleryProps> = (data) => <LabelGallery {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'LABEL_GALLERY')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 30,
    props: { ...data }
  }
}

export default LabelGalleryPage
